
/** package import */

import React, { useEffect, useState } from "react";

/** local file import */

import { getAccount } from "../Hooks/useAccounts";
import { getPoolInfoLimit, getPoolLength, getUser } from "../Hooks/useStake";
import LockedStackCont from "./LockedStackCont";
import HeaderNew from "./HeaderNew";
import bannerVideo from '../Assets/ainfra/videos/staking_video.mp4'
import FooterNew from "./FooterNew";
import { GetAllCmsData } from "../Hooks/UseBackend";


const LockedStake = () => {
    const [poolLimit, setPoolLimit] = useState([]);
    const [poolLength, setPoolLength] = useState(0);
    const [accountInfo, setAccountInfo] = useState(getAccount());
    const [CmsData, setCmsData] = useState([]);
    const [section1, setsection1] = useState();

    useEffect(() => {
        getCmsData();
    }, []);

    const getCmsData = async () => {
        console.log("enterthis");
        let res = await GetAllCmsData();

        if (res.data) {
            setsection1(res.data.find((value) => (value.identifier == 'AIF earn')))
        }


        setCmsData(res.data);
    };

    useEffect(() => {
        getData();
    });

    const getData = async () => {
        var data = await getPoolLength();

        console.log("poollength", data);

        if (data) setPoolLength(data);
        var pool = await getPoolInfoLimit(0, data);

        if (pool) {
            setPoolLimit(pool);
        }
    };

    useEffect(() => {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <div className="">
            <HeaderNew />
            <main className="">
                <section className='section-videoBanner'>
                    <div className='section-videoBanner__videoContainer'>
                        <video autoPlay muted loop className='section-videoBanner__video' >
                            <source src={bannerVideo} type="video/mp4" />
                        </video>
                    </div>
                    <div className='container ai-container'>
                        <div className='section-videoBanner__content'>
                            <p className='section-videoBanner__content-title'> {section1 && section1?.Title}  </p>
                            <p className='section-videoBanner__content-desc'> {section1 && section1?.Content}</p>
                        </div>
                    </div>
                </section>


                <section className="stakingcards">
                    <div className="container ai-container">
                        <div className="bordbox">
                            {/* <div className="stakingcardbox"> */}
                            <div className="row justify-content-center">

                                {/* {poolLimit &&
                                    poolLimit.map((val, index) =>

                                        <div className="col-12 col-lg-6 mb-4 pe-xl-4">
                                            <LockedStackCont
                                                datas={val}
                                                pid={index}
                                                accountInfo={accountInfo}
                                            />
                                        </div>
                                    )
                                } */}
                                {poolLimit &&
                                    poolLimit.map((val, index) =>
                                        index == 2 || index == 3 ? (

                                            <div className="col-12 col-lg-6 mb-4 pe-xl-4">
                                                <LockedStackCont
                                                    datas={val}
                                                    pid={index}
                                                    accountInfo={accountInfo}
                                                />
                                            </div>
                                        ) : <></>
                                    )
                                }


                                {/* {poolLimit &&
                                    poolLimit.map((val, index) =>

                                        index == 3
                                            ? (
                                                <div className="col-12 col-lg-6 ps-xl-4 mb-4">
                                                    <LockedStackCont
                                                        datas={val}
                                                        pid={index}
                                                        accountInfo={accountInfo}
                                                    />
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                    )} */}
                                {/* <div className='col-lg-4 col-md-6'>
                        <div className='launchbox p-sm-4 p-3 br-14 mt-sm-5 mt-3'>
                            <div className='d-flex align-items-center jc-between'>
                                <div className='logocont'><img src={logoicon} /> <span>LAbel M</span></div>  
                                <div>
                                <button className='ovalbtn'>Days</button>
                                </div>
                            </div>
                            
                            <div className='d-flex jc-between align-items-center mt-4'>
                                <p className='mb-0'>Unstake available after</p>
                            <button className='chocobtn'>LIVE</button>
                            </div>
                            <div className='bordbox p-4 br-14 my-3'>
                                <div className='d-flex jc-between gap-2'>
                                    <div>
                                    <div>
                                        <p className='mb-1'>Staked</p>
                                        <p>0.00</p>
                                    </div>
                                    <div>
                                        <p className='mb-1'>Earner MASP:</p>
                                        <p>0.00</p>
                                    </div>
                                    </div>
                                    
                                    <div>
                                        <p className='mb-1'>APR</p>
                                        <p><img src={calc} className="calcicon"/> 2%</p>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center mt-5 mb-4'>                             
                            <button className='btn getstarted'>Approve Contract</button></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6'>
                        <div className='launchbox p-sm-4 p-3 br-14 mt-sm-5 mt-3'>
                            <div className='d-flex align-items-center jc-between'>
                                <div className='logocont'><img src={logoicon} /> <span>LAbel M</span></div>  
                                <div>
                                <button className='ovalbtn'>Days</button>
                                </div>
                            </div>
                            
                            <div className='d-flex jc-between align-items-center mt-4'>
                                <p className='mb-0'>Unstake available after</p>
                            <button className='chocobtn'>LIVE</button>
                            </div>
                            <div className='bordbox p-4 br-14 my-3'>
                                <div className='d-flex jc-between gap-2'>
                                    <div>
                                    <div>
                                        <p className='mb-1'>Staked</p>
                                        <p>0.00</p>
                                    </div>
                                    <div>
                                        <p className='mb-1'>Earner MASP:</p>
                                        <p>0.00</p>
                                    </div>
                                    </div>
                                    
                                    <div>
                                        <p className='mb-1'>APR</p>
                                        <p><img src={calc} className="calcicon"/> 5%</p>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center mt-5 mb-4'> 
                            <button className='btn getstarted'>Unlock Wallet</button></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6'>
                        <div className='launchbox p-sm-4 p-3 br-14 mt-sm-5 mt-3'>
                            <div className='d-flex align-items-center jc-between'>
                                <div className='logocont'><img src={logoicon} /> <span>LAbel M</span></div>  
                                <div>
                                <button className='ovalbtn'>Days</button>
                                </div>
                            </div>
                            
                            <div className='d-flex jc-between align-items-center mt-4'>
                                <p className='mb-0'>Unstake available after</p>
                            <button className='chocobtn'>LIVE</button>
                            </div>
                            <div className='bordbox p-4 br-14 my-3'>
                                <div className='d-flex jc-between gap-2'>
                                    <div>
                                    <div>
                                        <p className='mb-1'>Staked</p>
                                        <p>0.00</p>
                                    </div>
                                    <div>
                                        <p className='mb-1'>Earner MASP:</p>
                                        <p>0.00</p>
                                    </div>
                                    </div>
                                    
                                    <div>
                                        <p className='mb-1'>APR</p>
                                        <p><img src={calc} className="calcicon"/> 0.05%%</p>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center mt-5 mb-4'> 
                            <button className='btn getstarted'>Unlock Wallet</button></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6'>
                        <div className='launchbox p-sm-4 p-3 br-14 mt-sm-5 mt-3'>
                            <div className='d-flex align-items-center jc-between'>
                                <div className='logocont'><img src={logoicon} /> <span>LAbel M</span></div>  
                                <div>
                                <button className='ovalbtn'>Days</button>
                                </div>
                            </div>
                            
                            <div className='d-flex jc-between align-items-center mt-4'>
                                <p className='mb-0'>Unstake available after</p>
                            <button className='chocobtn'>LIVE</button>
                            </div>
                            <div className='bordbox p-4 br-14 my-3'>
                                <div className='d-flex jc-between gap-2'>
                                    <div>
                                    <div>
                                        <p className='mb-1'>Staked</p>
                                        <p>0.00</p>
                                    </div>
                                    <div>
                                        <p className='mb-1'>Earner MASP:</p>
                                        <p>0.00</p>
                                    </div>
                                    </div>
                                    
                                    <div>
                                        <p className='mb-1'>APR</p>
                                        <p><img src={calc} className="calcicon"/> 2%</p>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center mt-5 mb-4'>                             
                            <button className='btn getstarted'>Unlock Wallet</button></div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6'>
                        <div className='launchbox p-sm-4 p-3 br-14 mt-sm-5 mt-3'>
                            <div className='d-flex align-items-center jc-between'>
                                <div className='logocont'><img src={logoicon} /> <span>LAbel M</span></div>  
                                <div>
                                <button className='ovalbtn'>Days</button>
                                </div>
                            </div>
                            
                            <div className='d-flex jc-between align-items-center mt-4'>
                                <p className='mb-0'>Unstake available after</p>
                            <button className='chocobtn'>LIVE</button>
                            </div>
                            <div className='bordbox p-4 br-14 my-3'>
                                <div className='d-flex jc-between gap-2'>
                                    <div>
                                    <div>
                                        <p className='mb-1'>Staked</p>
                                        <p>0.00</p>
                                    </div>
                                    <div>
                                        <p className='mb-1'>Earner MASP:</p>
                                        <p>0.00</p>
                                    </div>
                                    </div>
                                    
                                    <div>
                                        <p className='mb-1'>APR</p>
                                        <p><img src={calc} className="calcicon"/> 5%</p>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center mt-5 mb-4'> 
                            <button className='btn getstarted'>Unlock Wallet</button></div>
                        </div>
                    </div> */}
                            </div>
                        </div>
                    </div >
                </section >
            </main >
            <FooterNew />
        </div >
    );
};

export default LockedStake;
